import { render, staticRenderFns } from "./ConfiguracionInformeForm.vue?vue&type=template&id=675113c0"
import script from "./ConfiguracionInformeForm.vue?vue&type=script&lang=js"
export * from "./ConfiguracionInformeForm.vue?vue&type=script&lang=js"
import style0 from "./ConfiguracionInformeForm.vue?vue&type=style&index=0&id=675113c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports